/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Divider, Empty } from 'antd';
import { useState } from 'react';
import FloatingCard from '~components/FloatingCard';
import constants from '~util/constants';
import AircardTile from './components/AircardTile';
import CardTitle from './components/CardTitle';
import ReplaceAircardModal from './modals/ReplaceAircardModal';

const AircardsPane = ({ aircards = null, config, gridArea, updateConfig }) => {
  const [showReplaceAircardModal, setShowReplaceAircardModal] = useState(false);
  const [targetAircard, setTargetAircard] = useState();

  const { active, airlineCode } = config;

  // The aircard replace button will be disabled for any inactive system UNLESS it is
  // under the Bensenville (BENS) airline code (B-29891)
  const replaceDisabled = !active && airlineCode !== constants.BENSENVILLE_CODE;

  const handleReplace = aircard => {
    setTargetAircard(aircard);
    setShowReplaceAircardModal(true);
  };

  const handleCloseReplace = () => {
    setShowReplaceAircardModal(false);
    setTargetAircard();
  };

  const cssRootContainer = css`
    grid-area: ${gridArea};
    display: flex;
    flex-direction: column;

    width: auto;
    height: auto;

    border-style: solid;
    border-width: 2px 0 0 0;
    border-color: #1976d2ab;
  `;

  const cssContentContainer = css`
    display: flex;
    flex-direction: ${!!aircards?.length ? 'row' : 'column'};
    flex-grow: 1;

    justify-content: ${!!aircards?.length ? 'flex-start' : 'center'};
    align-items: center;

    width: 100%;
  `;

  return (
    <FloatingCard css={cssRootContainer} data-testid="aircards">
      <CardTitle>Aircards</CardTitle>
      <Divider
        style={{
          margin: '0.6rem 0',
        }}
      />
      <div css={cssContentContainer}>
        {!!aircards?.length ? (
          aircards.map((aircard, index) => (
            <AircardTile
              aircard={aircard}
              disabled={replaceDisabled}
              index={index}
              key={aircard.id}
              onReplace={handleReplace}
            />
          ))
        ) : (
          <Empty />
        )}
      </div>
      {!!aircards?.length && (
        <ReplaceAircardModal
          close={handleCloseReplace}
          config={config}
          prevAircard={targetAircard}
          updateConfig={updateConfig}
          visible={showReplaceAircardModal}
        />
      )}
    </FloatingCard>
  );
};

export default AircardsPane;
